import ActionsForm from '@/shared/mixins/actionsForm'
import {mask} from 'vue-the-mask'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import documentsmanagement from '@/shared/http/repositories/realestate/documentsmanagement'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },
  name: 'SearchCardDocument',
  data () {
    return {
      enterprises: [],
      customerCpf: '',
      search: {
        documentosObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        tipoPesquisa: 0,
        nomeDocumento: '',
        DocumentoId: '',
        empreendimentoId: '',
        clienteCpf: '',
        dataInicio: '',
        dataFim: ''
      }
    }
  },
  methods: {
    Search () {
      this.search.DocumentoId = this.search.documentosObj == null ? undefined : this.search.documentosObj.value
      var today = new Date()
      if (this.search.dataInicio !== '' && this.search.dataFim === '') {
        this.search.dataFim = today
      }
      this.search.clienteCpf = this.customerCpf.replace(/[().-]/gm, '')
      this.search.DocumentoId = this.search.documentosObj.value === null ? null : this.search.documentosObj.value
      this.$emit('dataSearch', this.search, true)
      localStoreHelper.gestao.documento(this.search)
    },
    cleanFilter () {
      this.customerCpf = ''
      this.search.empreendimentoId = ''
    },
    Clear () {
      this.$refs.documentoTypeahead.clear()
      Object.keys(this.search).forEach(prop => {
        if (prop === 'documentosObj') {
          this.search[prop].value = null
          return
        }
        if (prop !== 'tipoPesquisa') {
          this.search[prop] = ''
        } else {
          this.search[prop] = 0
        }
      })
      this.customerCpf = ''
      this.$emit('dataSearch', this.search, false)
      localStoreHelper.gestao.documento(null)
    }
  },
  mounted () {
    EnterpriseRepository.GetAll()
      .then(res => {
        if (res.status === 200) {
          this.enterprises = res.data.data
        }
      })
      .catch(res => console.log(res))

    documentsmanagement.GetAllEmpreendimento()
      .then(res => {
        if (res.status === 200) {
          this.documentsArray = res.data.data
        }
      })
      .catch(res => console.log(res))
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/documentsManagement/components/SearchCardDocument/SearchCardDocument.js